export default __webpack_public_path__ + "static/media/100_19519.f3f73189.jpg";